<script setup lang="ts">
import L, { divIcon, point } from 'leaflet';
import { LMap, LTileLayer } from '@vue-leaflet/vue-leaflet';
import { LMarkerClusterGroup } from 'vue-leaflet-markercluster';
import { render } from 'vue';
import ClusterIcon from './ClusterIcon.vue';

import 'leaflet/dist/leaflet.css';
import 'vue-leaflet-markercluster/dist/style.css';

defineProps<{
    center: any;
}>();
globalThis.L = L;

const zoom = defineModel<number>('zoom', { default: 3 });

function createClusterIcon(cluster: any) {
    const count = cluster.getChildCount();

    // 1. Create a Vue vnode
    const vnode = h(ClusterIcon, { count });

    // 2. Mount it to an off-DOM container
    const container = document.createElement('div');
    render(vnode, container);

    // 3. Pass the rendered HTML to Leaflet
    return divIcon({
        html: container.innerHTML,
        className: 'custom-cluster-wrapper',
        iconSize: point(40, 40),
    });
}
</script>

<template>
    <LMap
        v-model:zoom="zoom"
        :center
        :options="{ zoomControl: false }"
        use-global-leaflet
    >
        <LTileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            layer-type="base"
            name="Stadia Maps Basemap"
        />
        <LMarkerClusterGroup :icon-create-function="createClusterIcon">
            <slot />
        </LMarkerClusterGroup>
    </LMap>
</template>

<style>
.custom-cluster-wrapper {
    background: transparent;
    border: none;
}

#map {
    width: 100%;
}
</style>
